import { render, staticRenderFns } from "./TemplateSchemaSettingsCollectionList.vue?vue&type=template&id=5bbbf5ce&"
import script from "./TemplateSchemaSettingsCollectionList.vue?vue&type=script&lang=js&"
export * from "./TemplateSchemaSettingsCollectionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports